<template>
  <div class="content">
    <a-button icon="left" style="background-color: transparent" @click="back">{{ $t('chat.history.back') }}</a-button>
    <div class="tableContent" ref="table">
      <a-table :columns="columns" :pagination="pagination" :data-source="data" @change="handerChange" :getPopupContainer="getPopupContainer" rowClassName="test" :scroll="{ y: 'calc(100vh - 260px)' }">
        <span slot="type" slot-scope="text, record">
          {{ selectedAppName }}
        </span>
        <span slot="created_at" slot-scope="text, record">
          {{ new Date(text * 1000).toLocaleString() }}
        </span>
        <span slot="action" slot-scope="text, record">
          <img class="view operation" @click="view(record)" src="@/assets/icons/ai_history_view.png" alt="" />
          <img class="edit operation" @click="edit(record)" src="@/assets/icons/ai_history_edit.png" alt="" />
          <img class="delete operation" style="width: 16px;" @click="deleteHistory(record)" src="@/assets/icons/ai_history_delete.png" alt="" />
        </span>
      </a-table>
      <div class="pagination">
        <a-icon @click="previous" :class="{noClick: page === 1}" type="left" />
        <span>{{ page }}</span>
        <a-icon @click="next" :class="{noClick: !hasMore}" type="right" />
      </div>
    </div>
    <!-- 删除确认弹窗 -->
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${$t('chat.history.deleteConfirm')}</p>
        <p class='placeholder'>${$t('chat.history.deleteAfterTip')}</p>`
      "
    />

    <!-- 编辑弹窗 -->
    <a-modal :title="$t('chat.history.rename')" :visible="editVisible" @ok="handleEditOk" @cancel="handleEditCancel">
      <a-form-model ref="editForm" :model="editForm" :rules="editRules">
        <a-form-model-item :label="$t('chat.history.titleName')" prop="title">
          <a-input v-model="editForm.title" :placeholder="$t('chat.history.inputTitlePlaceholder')" maxLength="30" allowClear />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getAiAppList, updateAIChatHistory, deleteAIChatHistory } from '@/api/aiApp.js'
import TipModal from '@/components/tipModal/index.vue'
import { app, baseApp, teachingPlan, course } from '@/data/app.js'

const result = []
function traverse(list) {
  list.forEach(item => {
    if (item.id && item.name) {
      result.push({ text: item.name, value: item.id })
    }
    if (item.children) {
      traverse(item.children)
    }
  })
}
traverse([baseApp, ...app])
const appMap = result
console.log(appMap)

export default {
  data() {
    return {
      selectedAppName: '',
      appMap,
      columns: [
        {
          title: this.$t('chat.history.type'),
          dataIndex: 'type',
          key: 'type',
          align: 'center',
          filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
          filterMultiple: false,
          filteredValue: [],
          filters: appMap,
          scopedSlots: { customRender: 'type' }
        },
        {
          title: this.$t('chat.history.titleName'),
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('chat.history.editTime'),
          dataIndex: 'created_at',
          key: 'created_at',
          sorter: (a, b) => a.created_at - b.created_at,
          scopedSlots: { customRender: 'created_at' }
        },
        {
          title: this.$t('chat.history.operations'),
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      data: [],
      pagination: {
        defaultPageSize: 20,
      },
      delVisible: false, // 控制删除确认弹窗的显示
      delId: null, // 要删除的记录ID
      editVisible: false, // 控制编辑弹窗的显示
      editForm: {
        id: null,
        title: '' // 假设只编辑标题，根据实际需求调整
      },
      editRules: {
        title: [
          { required: true, message: this.$t('chat.history.titleRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('chat.history.titleMaxLength'), trigger: 'blur' }
        ]
      },
      page: 1,
      currentLastIdArray: [],
      hasMore: true,
    }
  },
  components: {
    TipModal
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    getPopupContainer(triggerNode) {
      return this.$refs.table
    },
    handerChange(pagination, filters, sort) {
      console.log(filters, sort, sort.order)
      if (filters.type.length > 0) {
        this.selectedAppId = filters.type[0]
        this.selectedAppName = appMap.find(item => item.value === this.selectedAppId)?.text
        this.columns[0].filteredValue = [this.selectedAppId]
      }
      this.page = 1
      this.classId = filters.type && filters.type.length > 0 ? filters.type[0] : undefined
      this.sortBy = sort.order === 'ascend' ? 'updated_at' : sort.order === 'descend' ? '-updated_at' : null
      this.getData()
      // this.data = []
    },
    async getData(lastId) {
      const res = await getAiAppList(
        {
          last_id: lastId,
          sort_by: this.sortBy,
          limit: 20
        },
        {
          'X-App-Id': this.selectedAppId
        }
      )
      console.log(res)
      this.data = res.data
      if (res.data.length > 0) {
        this.currentLastIdArray[this.page - 1] = res.data[res.data.length - 1].id
      }
      this.hasMore = res.has_more
    },
    previous() {
      if (this.page > 1) {
        this.page--
        this.getData(this.currentLastIdArray[this.page - 2])
      }
    },
    next() {
      if (!this.hasMore) return
      this.page++
      this.getData(this.currentLastIdArray[this.page - 2])
    },
    // 查看历史记录详情
    view(record) {
      if (this.selectedAppId === course.id) {
        // 跳转到智能课程生成详情页
        this.$router.push({
          name: 'generationCourse',
          query: {
            id: this.selectedAppId,
            conversationId: record.id
          }
        })
      } else if (this.selectedAppId === teachingPlan.id) {
        // 跳转到智能教案生成详情页
        this.$router.push({
          name: 'aiChatTeachingPlan',
          query: {
            id: this.selectedAppId,
            conversationId: record.id
          }
        })
      } else {
        console.log(record)
        this.$router.push({
          name: 'aiChat',
          query: {
            id: this.selectedAppId,
            conversationId: record.id
          }
        })
      }
    },

    // 编辑历史记录
    edit(record) {
      this.editForm.id = record.id
      this.editForm.title = record.name // 修改这里，使用 name 而不是 title
      this.editVisible = true
    },

    // 确认编辑
    handleEditOk() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          try {
            // 使用POST方法调用 /conversations/:conversation_id/name 接口
            await updateAIChatHistory(this.editForm.id, {
              name: this.editForm.title
            }, {
              'X-App-Id': this.selectedAppId
            })
            this.$message.success(this.$t('chat.history.renameSuccess'))
            this.editVisible = false
            this.getData() // 刷新列表
          } catch (error) {
            this.$message.error(this.$t('chat.history.renameFailed'))
            console.error(error)
          }
        }
      })
    },

    // 取消编辑
    handleEditCancel() {
      this.editVisible = false
      this.$refs.editForm.resetFields()
    },

    // 删除历史记录确认
    deleteHistory(record) {
      this.delId = record.id
      this.delVisible = true
    },

    // 确认删除
    async del() {
      try {
        // 使用DELETE方法调用 /conversations/:conversation_id 接口
        await deleteAIChatHistory(this.delId, {
          'X-App-Id': this.selectedAppId
        })
        this.$message.success(this.$t('chat.history.deleteSuccess'))
        this.delVisible = false
        this.getData() // 刷新列表
      } catch (error) {
        this.$message.error(this.$t('chat.history.deleteFailed'))
        console.error(error)
      }
    }
  },
  mounted() {
    this.selectedAppId = this.$route.query.id
    this.selectedAppName = appMap.find(item => item.value === this.selectedAppId)?.text
    this.columns[0].filteredValue = [this.selectedAppId]
    this.getData()
  }
}
</script>

<style scoped lang="less">
.content {
  padding: 26px 19px;
  /deep/ .ant-btn {
    border-radius: 20px;
    &:hover{
      color: rgba(0, 0, 0, 0.65);
      border-color: rgb(217, 217, 217);
    }
  }
  .active {
    box-shadow: none;
    width: 120px;
  }
  .default {
    box-shadow: none;
    width: 120px;
    background: #edf3fa;
    color: #6b738c !important;
  }
  /deep/.operation{
    width: 19px;
    cursor: pointer;
    margin: 0 10px;
    height: auto;
  }
  /deep/.ant-table-filter-dropdown-link.clear{
    display: none;
  }
  /deep/.ant-table-filter-dropdown-btns{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tableContent{
    padding-top: 20px;
    position: relative;
  }
  .pagination{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    span{
      margin: 0 10px;
    }
    .noClick{
      cursor: not-allowed;
      color: #ccc;
    }
  }
}
</style>
